import React, { useState, useContext } from "react";
import { Loader } from 'pixi.js'
import { Sprite, Container, withFilters } from '@inlet/react-pixi'
import { GlowFilter } from 'pixi-filters';

import HomeContext from '../../../context/home-context';

const Filters = withFilters(Container, {
    glow: GlowFilter,
});

const TraitContainer = () => {

    const { homeContext, handleClick } = useContext(HomeContext);
    const loader = Loader.shared;

    //Trait Title
    //normal
    let mindsetTitleNormal = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures["mindset_normal.png"];
    let wellbeingTitleNormal = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures["wellbeing_normal.png"];
    let resilienceTitleNormal = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures["grit_normal.png"];
    let learningTitleNormal = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures["approaches_normal.png"];

    //mouseover
    let mindsetTitleHover = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures["mindset_mouseover.png"];
    let wellbeingTitleHover = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures["wellbeing_mouseoever.png"];
    let resilienceTitleHover = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures["grit_mouseover.png"];
    let learningTitleHover = loader.resources["./assets/images/components/island/spritesheets/skyAssets/text_sun_moon_road.json"].textures["approaches_mouseover.png"];

    const [mindsetTitle, setmindsetTitle] = useState(mindsetTitleNormal);
    const [wellbeingTitle, setwellbeingTitle] = useState(wellbeingTitleNormal);
    const [resilienceTitle, setresilienceTitle] = useState(resilienceTitleNormal);
    const [learningTitle, setlearningTitle] = useState(learningTitleNormal);
    const [mindsetOn, setmindsetOn] = useState(0);
    const [wellbeingOn, setwellbeingOn] = useState(0);
    const [resilienceOn, setresilienceOn] = useState(0);
    const [learningOn, setlearningOn] = useState(0);

    //Trait Texture
    const mindsetTexture = loader.resources["./assets/images/components/island/spritesheets/traits/mindset.json"].textures[homeContext.mindset.texture]
    const wellbeingTexture = loader.resources["./assets/images/components/island/spritesheets/traits/wellbeing.json"].textures[homeContext.wellbeing.texture]
    const resilienceTexture = loader.resources["./assets/images/components/island/spritesheets/traits/resilience.json"].textures[homeContext.resilience.texture]
    const learningTexture = loader.resources["./assets/images/components/island/spritesheets/traits/learning.json"].textures[homeContext.learning.texture]

    const filterOn = (id) => {
        switch (id) {
            case 1: setmindsetOn(0.5);
                setmindsetTitle(mindsetTitleHover);
                break;
            case 2: setwellbeingOn(0.5);
                setwellbeingTitle(wellbeingTitleHover);
                break;
            case 3: setresilienceOn(0.5);
                setresilienceTitle(resilienceTitleHover);
                break;
            case 4: setlearningOn(0.5);
                setlearningTitle(learningTitleHover);
                break;
        }
    }

    const filterOff = (id) => {
        switch (id) {
            case 1: setmindsetOn(0);
                setmindsetTitle(mindsetTitleNormal);
                break;
            case 2: setwellbeingOn(0);
                setwellbeingTitle(wellbeingTitleNormal);
                break;
            case 3: setresilienceOn(0);
                setresilienceTitle(resilienceTitleNormal);
                break;
            case 4: setlearningOn(0);
                setlearningTitle(learningTitleNormal);
                break;
        }
    }

    return (
        <>
            <Container x={10} y={90}>
                <Filters scale={1} glow={{ distance: 100, outerStrength: wellbeingOn, innerStrength: wellbeingOn, quality: 0 }}>
                    <Sprite texture={wellbeingTexture} x={825} y={115} scale={{ x: 0.4, y: 0.4 }} />
                </Filters>
                <Filters scale={1} glow={{ distance: 100, outerStrength: resilienceOn, innerStrength: resilienceOn, quality: 0 }}>
                    <Sprite texture={resilienceTexture} x={682} y={212} scale={{ x: 0.4, y: 0.4 }} />
                </Filters>

                <Filters scale={1} glow={{ distance: 100, outerStrength: mindsetOn, innerStrength: mindsetOn, quality: 0 }}>
                    <Sprite texture={mindsetTexture} x={825} y={280} scale={{ x: 0.4, y: 0.4 }} />

                </Filters>
                <Filters scale={1} glow={{ distance: 100, outerStrength: learningOn, innerStrength: learningOn, quality: 0 }}>
                    <Sprite texture={learningTexture} x={970} y={222} scale={{ x: 0.4, y: 0.4 }} />
                </Filters>
            </Container>

            <Container x={300} y={70}>
                <Sprite texture={mindsetTitle} x={600} y={480} scale={{ x: 0.4, y: 0.4 }}
                    interactive={true} buttonMode={true}
                    pointerdown={() => { handleClick(homeContext.mindset) }}
                    pointerover={() => filterOn(1)}
                    pointerout={() => filterOff(1)}
                />
                <Sprite texture={wellbeingTitle} x={580} y={80} scale={{ x: 0.4, y: 0.4 }}
                    interactive={true} buttonMode={true}
                    pointerdown={() => { handleClick(homeContext.wellbeing) }}
                    pointerover={() => filterOn(2)}
                    pointerout={() => filterOff(2)}
                />
                <Sprite texture={resilienceTitle} x={180} y={230} scale={{ x: 0.4, y: 0.4 }}
                    interactive={true} buttonMode={true}
                    pointerdown={() => { handleClick(homeContext.resilience) }}
                    pointerover={() => filterOn(3)}
                    pointerout={() => filterOff(3)}
                />
                <Sprite texture={learningTitle} x={930} y={230} scale={{ x: 0.4, y: 0.4 }}
                    interactive={true} buttonMode={true}
                    pointerdown={() => { handleClick(homeContext.learning) }}
                    pointerover={() => filterOn(4)}
                    pointerout={() => filterOff(4)}
                />
            </Container>
        </>
    );
};

export { TraitContainer as default }
